import CT from '@marketplace-ai/tags';
import { useSelector } from '@xstate/react';
import type { ReactNode } from 'react';
import { CostCalculator } from '../../listings';
import { useMsaasListingSearchRef } from '../../marketSelectors';
import { useSearchSide } from '../searchSide';

/**
 * [MCV-1955] The Compensation tab's frame, shared with the provider Job listing view: the
 * `b2b-compensation` class carries the readable table/summary sizing from listingPresentation.css.
 * The calculator itself differs by listing type (Job adds on-call shifts), so the caller supplies it.
 */
export const CompensationLayout = ({
  dataCy = CT.listingSearch.costCalculator,
  children,
}: {
  dataCy?: string;
  children: ReactNode;
}) => (
  <div className="b2b-compensation min-w-0 text-left text-[1rem] leading-6" data-cy={dataCy}>
    <div className="text-xl font-bold leading-snug mt-6 mb-4">Compensation</div>
    {children}
  </div>
);

export const Compensation = () => {
  const { msaasListingsSearchRef } = useMsaasListingSearchRef();
  const side = useSearchSide();
  const context = useSelector(msaasListingsSearchRef, (state) => state?.context);
  if (!msaasListingsSearchRef || !context) return null;
  const { listing } = context;

  return (
    <CompensationLayout>
      <CostCalculator
        detail={listing?.detail}
        loading={false}
        showHeading={false}
        failureAudience="provider"
        side={side}
      />
    </CompensationLayout>
  );
};
